import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert,
  Button,
  Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * مكون تصحيح أخطاء دفع الديون
 * يستخدم لتشخيص وحل مشاكل نظام الدفع
 */
const DebtPaymentDebugger: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ fontFamily: 'Cairo', fontWeight: 'bold' }}>
        🔧 تصحيح أخطاء دفع الديون
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        هذا المكون مخصص لتشخيص وحل مشاكل نظام دفع الديون في النظام
      </Alert>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ fontFamily: 'Cairo' }}>
            الميزات المتاحة:
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: 'Cairo', mb: 2 }}>
            • تشخيص مشاكل الدفع التلقائي
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: 'Cairo', mb: 2 }}>
            • فحص سجلات المعاملات
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: 'Cairo', mb: 2 }}>
            • إعادة حساب المبالغ المستحقة
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: 'Cairo', mb: 2 }}>
            • تنظيف البيانات التالفة
          </Typography>
        </CardContent>
      </Card>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
        <Button
          variant="contained"
          onClick={() => navigate('/admin/debts')}
          sx={{ fontFamily: 'Cairo' }}
        >
          العودة إلى صفحة الديون
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigate('/admin')}
          sx={{ fontFamily: 'Cairo' }}
        >
          العودة للوحة التحكم
        </Button>
      </Box>
    </Box>
  );
};

export default DebtPaymentDebugger;
